var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCertShieldBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 40,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1E1E1E",
  d: "M36.927 8.974a1.424 1.424 0 0 0-.864-1.497L19.017.37a1.42 1.42 0 0 0-1.095 0L.876 7.477c-.593.247-.947.86-.864 1.496l2.37 18.315c.048.377.245.718.547.949l14.676 11.21c.51.389 1.218.389 1.729 0l14.676-11.21c.302-.23.499-.572.548-.949z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFEF2",
  d: "m18.528 18.534-1.873-6.507h-5.178v1.052h.496c.613 0 1.12.355 1.31 1.031l2.851 9.924h2.604l1.275-4.405-.02-.02c-.832 0-1.236-.306-1.465-1.06v-.015M29.016 22.969c-.613 0-1.1-.404-1.285-1.051l-2.852-9.904H20.9l3.445 11.992h5.168v-1.052h-.496v.015M7.844 22.97v1.052h4.594V22.97z"
})));
export default SvgCertShieldBlack;